import React from "react";
import { humanReadableDate } from "../../../../../app/utils";
import { BackButton, LineSeperator } from "../../../../../components/RegularComponents";
import { InformationDetailPanelSection } from '../../InformationDetailPanelSection';
import "../../BLTInformation.styles.scss"

export const LicenceSuspensionDetails = (props) => {
    const { criminalHistoryItem, setCriminalHistoryItem } = props
    const handleGoBack = () => {
        setCriminalHistoryItem()
    }

    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <div className="licence-application-details-panel">
                <InformationDetailPanelSection header={"Licence type"} value={criminalHistoryItem.businessLicenceType} />
                <LineSeperator />

                <InformationDetailPanelSection header={"Licence action"} value={criminalHistoryItem.action} />
                <LineSeperator />

                <InformationDetailPanelSection header={"Province"} value={criminalHistoryItem.province} />
                <LineSeperator />

                <InformationDetailPanelSection header={"Start date"} value={humanReadableDate(criminalHistoryItem.suspensionDate)} />
                <LineSeperator />

                <InformationDetailPanelSection header={"Reason"} value={criminalHistoryItem.reason} />
                <LineSeperator />
            </div>

        </div>
    )
}
